// Epoch 26: Authenticated Layout with Global Trial Banner
// This layout wraps all authenticated pages to show the trial banner consistently
// Date: August 7, 2025

import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../Header';
import TrialBanner from '../trial/TrialBanner';
import { useTrialContext } from '../../hooks/useTrialContext';

interface AuthenticatedLayoutProps {
  children: React.ReactNode;
  showHeader?: boolean;
  showTrialBanner?: boolean;
}

const AuthenticatedLayout: React.FC<AuthenticatedLayoutProps> = ({ 
  children, 
  showHeader = true,
  showTrialBanner = true 
}) => {
  const navigate = useNavigate();
  const trial = useTrialContext();
  
  // Determine if we should show the trial banner
  const shouldShowTrialBanner = showTrialBanner && (
    trial.isTrialActive || trial.isTrialExpired
  );

  console.log('🎯 AuthenticatedLayout - Trial Banner Check:', {
    showTrialBanner,
    isTrialActive: trial.isTrialActive,
    isTrialExpired: trial.isTrialExpired,
    shouldShowTrialBanner,
    daysRemaining: trial.daysRemaining
  });

  const handleUpgrade = () => {
    // Epoch 26: Navigate to pricing page instead of profile billing
    navigate('/pricing');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {showHeader && <Header />}
      
      {/* Global Trial Banner - Shows on all authenticated pages */}
      {shouldShowTrialBanner && (
        <TrialBanner 
          daysRemaining={trial.daysRemaining}
          onUpgrade={handleUpgrade}
          campaignsCreated={trial.campaignsUsed}
          maxCampaigns={trial.maxCampaigns}
          variant={
            trial.isTrialExpired ? 'urgent' :
            trial.daysRemaining <= 1 ? 'urgent' :
            trial.daysRemaining <= 3 ? 'warning' : 
            'info'
          }
        />
      )}
      
      {/* Page Content */}
      <div className="authenticated-content">
        {children}
      </div>
    </div>
  );
};

export default AuthenticatedLayout;